import type { ReactNode } from 'react';

interface WrapperProps {
  children: ReactNode;
}

export function Wrapper({ children }: WrapperProps) {
  return (
    <div className="flex min-h-screen flex-col overflow-hidden">
      {children}
    </div>
  );
}
